// src/pages/Payment/PaymentLauncherPage.tsx
import React, { useEffect, useState } from "react";
import { loadTossPayments, TossPaymentsWidgets } from "@tosspayments/tosspayments-sdk";
import { nanoid } from "nanoid";
import styles from "./Payment.module.css";

const clientKey = "test_gck_kYG57Eba3G6AN9z6aAAz8pWDOxmA";

const PaymentLauncherPage: React.FC = () => {
  const [widgets, setWidgets] = useState<TossPaymentsWidgets | null>(null);
  const [info, setInfo] = useState<any>(null);
  const [ready, setReady] = useState(false);
  const [isPaying, setIsPaying] = useState(false);

  useEffect(() => {
    (async () => {
      // localStorage 키로 결제 정보 읽기
      const key = new URLSearchParams(window.location.search).get("key") ?? "paypalPaymentInfo";
      let raw = localStorage.getItem(key);
      if (!raw && window.opener && window.opener.localStorage) {
        try { raw = window.opener.localStorage.getItem(key); } catch {}
      }
      if (!raw) {
        alert("결제 정보가 없습니다. 창을 닫습니다.");
        window.close();
        return;
      }
      const _info = JSON.parse(raw);
      setInfo(_info);
      // 사용 후 정리
      localStorage.removeItem(key);
      try { window.opener?.localStorage?.removeItem(key); } catch {}

      try {
        const tossPayments = await loadTossPayments(clientKey);
        const w = tossPayments.widgets({ customerKey: _info.customerKey ?? nanoid() });

        const amount =
          _info.amount?.currency
            ? { value: Number(_info.amount.value.toFixed(2)), currency: _info.amount.currency }
            : { value: Number(Number(_info.amount?.value ?? 0).toFixed(2)), currency: "USD" };

        await w.setAmount(amount);

        await Promise.all([
          w.renderPaymentMethods({ selector: "#payment-method", variantKey: "PAYMENT_USD" }),
          w.renderAgreement({ selector: "#agreement", variantKey: "AGREEMENT" }),
        ]);

        setWidgets(w);
        setReady(true);
      } catch (e) {
        console.error("[LAUNCHER][INIT_ERR]", e);
        alert("결제 위젯 초기화 중 오류가 발생했습니다.");
        window.close();
      }
    })();
  }, []);

  const handlePay = async () => {
    if (!widgets || !info || isPaying) return;
    setIsPaying(true);
    try {
      await widgets.requestPayment({
        orderId: info.orderId,
        orderName: "IOPS SPACE",
        successUrl: `${window.location.origin}/mypage/payment/success`,
        failUrl: `${window.location.origin}/mypage/payment/fail`,
      });
    } catch (e: any) {
      console.error("[LAUNCHER][REQUEST_ERR]", e);
      alert(e?.message || e?.code || "결제 요청 중 오류가 발생했습니다. 약관 동의 후 다시 시도해주세요.");
      setIsPaying(false);
    }
  };

  return (
    <div style={{ 
      padding: 32, 
      width: '100%',
      maxWidth: 600,  // 440 -> 600으로 증가
      margin: '40px auto',
      background: '#f8f9fa',
      borderRadius: 12,
      minHeight: '600px'  // 최소 높이 설정
    }}>
      <h2 style={{ 
        textAlign: 'center', 
        marginBottom: 24, 
        color: '#333',
        fontSize: 20,
        fontWeight: 600
      }}>
        PayPal Payment
      </h2>
      
      <div className={styles.tossCard} style={{
        maxWidth: 520,  // 카드 최대 너비 증가
        margin: '0 auto',
        padding: 24
      }}>
        <div 
          id="payment-method" 
          className={styles.tossReset}
          style={{ 
            minHeight: 200  // PayPal 버튼 영역 최소 높이
          }}
        />
        <div 
          id="agreement" 
          className={styles.tossReset} 
          style={{ 
            marginTop: 20,
            minHeight: 100
          }}
        />
      </div>

      <p style={{ 
        marginTop: 20, 
        fontSize: 15, 
        opacity: 0.8,
        textAlign: 'center',
        padding: '0 20px'
      }}>
        PayPal 버튼을 선택하고, 약관에 동의한 뒤 아래 버튼으로 결제를 진행하세요.
      </p>

      <button
        onClick={handlePay}
        disabled={!ready || isPaying}
        style={{
          marginTop: 24,
          width: '100%',
          maxWidth: 480,  // 버튼 너비 증가
          height: 52,      // 버튼 높이 증가
          borderRadius: 8,
          border: 'none',
          cursor: ready && !isPaying ? 'pointer' : 'not-allowed',
          fontSize: 17,
          fontWeight: 600,
          background: ready && !isPaying ? '#0A84FF' : '#ccc',
          color: '#fff',
          display: 'block',
          margin: '24px auto 0',
          transition: 'background 0.2s ease'
        }}
        onMouseEnter={(e) => {
          if (ready && !isPaying) {
            e.currentTarget.style.background = '#0070E0';
          }
        }}
        onMouseLeave={(e) => {
          if (ready && !isPaying) {
            e.currentTarget.style.background = '#0A84FF';
          }
        }}
      >
        {isPaying ? 'Redirecting to PayPal...' : 'Pay with PayPal'}
      </button>
    </div>
  );
};

export default PaymentLauncherPage;